<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex row flex-center">
        <router-view />
      </q-page>
    </q-page-container>
  </q-layout>
</template>
